import { Layout } from "antd";
import ClientHeader from "./ClientHeader";

const ClientLayout = ({ children, head, footer = true,bg=true }) => {
  return (
    <Layout
      style={{
        backgroundColor: "transparent",
        scrollBehavior: "smooth",
        position: "relative",
      }}
    >
      <ClientHeader />
      <span className="">
        {children}
        {/* {footer && <ClientFooter />} */}
      </span>
    </Layout>
  );
};
export default ClientLayout;
